import isEmpty from 'lodash/isEmpty'
import { SET_FILTERS, SET_AVAILABLE_FILTERS } from '@/store/mutation-types'
import service from '@/service'
import parseFilter from '@/assets/js/parseFilter'

const state = {
  filters: [],
  availableFilters: []
}

const getters = {
  filtersCount (state) {
    return state.filters.length
  },
  availableFilters (state) {
    return state.availableFilters.map(({ name }) => parseFilter(name))
  }
}

const mutations = {
  [SET_FILTERS] (state, filters = []) {
    state.filters = filters.map(filter => parseFilter(filter))
  },
  [SET_AVAILABLE_FILTERS] (state, filters) {
    state.availableFilters = filters
  }
}

const actions = {
  async fetchAvailableFilters ({ commit, state }) {
    if (!isEmpty(state.availableFilters)) return

    const filters = await service.filters.list()
    commit(SET_AVAILABLE_FILTERS, filters)
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/filters.js